import { render, staticRenderFns } from "./Typography5.vue?vue&type=template&id=c31f1532&scoped=true"
import script from "./Typography5.vue?vue&type=script&lang=js"
export * from "./Typography5.vue?vue&type=script&lang=js"
import style0 from "./Typography5.vue?vue&type=style&index=0&id=c31f1532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31f1532",
  null
  
)

export default component.exports